import styled from 'styled-components/macro';
import { fontSize02, fontSize03, fontSize04, fontSize05, fontSize06, fontSize07 } from '../styling/fonts';
import { spacing06 } from '../styling/spacing';

export const Header1 = styled.h1`
  font-size: ${fontSize07};
  margin-bottom: ${spacing06};
`;

export const Header2 = styled.h2`
  font-size: ${fontSize06};
`;

export const Header3 = styled.h3`
  font-size: ${fontSize05};
`;

export const Header4 = styled.h4`
  font-size: ${fontSize04};
`;

export const Header5 = styled.h5`
  font-size: ${fontSize03};
`;

export const Header6 = styled.h6`
  font-size: ${fontSize02};
`;
